import React from "react";
import { Permissions } from "../../app/constants/permissions";
import { useAuth } from "../../app/auth/useAuth";
import { useChannelAvailability } from "../../app/integrations/useChannelAvailability";
import type { SettingsVisibilityContext } from "./settingsCatalog";

/**
 * Sichtbarkeitskontext der Einstellungsseiten für den angemeldeten Benutzer. Gemeinsame Quelle für die
 * Gruppenseiten und die Schnellsuche — beide müssen dieselben Seiten zeigen.
 */
export function useSettingsVisibilityContext(): SettingsVisibilityContext {
  const auth = useAuth();
  const channelAvailability = useChannelAvailability();
  const rawCaps = auth.info?.capabilities;
  const role = auth.info?.role || "";
  const isOwnerOrAdmin = auth.hasRole("admin") || auth.hasPermission(Permissions.BillingWrite);
  return React.useMemo(
    () => ({
      capabilities: rawCaps,
      role,
      isOwnerOrAdmin,
      hasAnyPermission: (...permissions: string[]) => auth.hasAnyPermission(...permissions),
      channels: channelAvailability.canSend
    }),
    [auth, channelAvailability.canSend, rawCaps, role, isOwnerOrAdmin]
  );
}
